import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function StartCampaignIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "123.747"}
      height={height || "117.176"}
      viewBox="0 0 123.747 117.176"
    >
      <g id="Illustration" transform="translate(0 0.2)">
        <path
          id="Path_10206"
          data-name="Path 10206"
          d="M7.8,56.717H66.329V102.58h6.017v7.99l-4.091,3.646H7.084L2.9,111.178v-8.6H7.8Z"
          fill="#fff2e5"
        />
        <path
          id="Path_10189"
          data-name="Path 10189"
          d="M199.848,144.889v-4.6l3.14-4.016,8.8-5.2,22.152-23.27,18.316,31.768L223.328,149.1l5.88,10.976-2.12,3.416h-5.232l-5.863-10.89-4.959,2.994h-5.107l-1.872-2.994-4.939,2.994-4.389-2.12v-5.014Z"
          transform="translate(-177.607 -69.589)"
          fill="#fff"
        />
        <path
          id="Path_10174"
          data-name="Path 10174"
          d="M74.751,77.729H70.594V50.979a2.079,2.079,0,0,0-4.157,0V77.729H12.393V36.157H41.114a2.079,2.079,0,0,0,0-4.157h-30.8a2.079,2.079,0,0,0-2.079,2.079v43.65H4.079A2.079,2.079,0,0,0,2,79.808v4.157A10.393,10.393,0,0,0,12.393,94.358H66.436A10.393,10.393,0,0,0,76.829,83.965V79.808A2.079,2.079,0,0,0,74.751,77.729Zm-2.079,6.236A6.236,6.236,0,0,1,66.436,90.2H12.393a6.236,6.236,0,0,1-6.236-6.236V81.886H72.672Z"
          transform="translate(-2 22.618)"
          fill="#fb972e"
        />
        <path
          id="Path_10188"
          data-name="Path 10188"
          d="M59.1,34.845a2.086,2.086,0,0,0-3.617,2.079L65.9,55.278,37.627,65.255h-.312l-5.4,3.118-3.6,2.079a4.15,4.15,0,0,1-5.675-1.517l-4.157-7.192a4.157,4.157,0,0,1,1.559-5.487L27.234,52.1l8.607,14.671a2.086,2.086,0,1,0,3.617-2.079L30.685,49.749,50.535,28.235l5.847,10.186A2.086,2.086,0,0,0,60,36.343L52.926,24.036a2.106,2.106,0,0,0-3.139-.561L26.923,47.462l-8.855,5.113a8.314,8.314,0,0,0-3.825,9.416l-2.079,1.185a6.231,6.231,0,0,0,3.118,11.64,6.361,6.361,0,0,0,3.118-.831L20.479,72.8a8.065,8.065,0,0,0,3.638,2.162,7.877,7.877,0,0,0,2.183.291,8.19,8.19,0,0,0,4.157-1.122l1.808-1.039L36.422,80.3A6.23,6.23,0,1,0,47.21,74.068l-3.783-6.589,26.19-9.208A2.085,2.085,0,0,0,70.7,55.3ZM16.239,70.368a2.077,2.077,0,1,1-2.079-3.6l1.808-1.039,2.079,3.6Zm27.354,5.82A2.077,2.077,0,0,1,40,78.267L35.84,71.054l3.45-1.975h.166Z"
          transform="translate(5.587 12.913)"
          fill="#fb972e"
        />
        <path
          id="webhook"
          d="M15.279,4a5.556,5.556,0,0,0-3.3,10.047L9.227,18.6l-.07-.017a2.246,2.246,0,1,0,1.361,1.047,2.327,2.327,0,0,0-.349-.436L13.2,14.2l.3-.488-.488-.279a4.468,4.468,0,1,1,6.732-3.855,4.378,4.378,0,0,1-.192,1.308l1.064.331a5.515,5.515,0,0,0,.244-1.639A5.589,5.589,0,0,0,15.279,4Zm0,3.349a2.233,2.233,0,1,0,.541,4.4l2.686,4.866.262.488.506-.262a4.4,4.4,0,0,1,2.145-.558,4.465,4.465,0,1,1-3.1,7.674l-.767.8a5.579,5.579,0,1,0,3.872-9.593,5.493,5.493,0,0,0-2.163.488L16.8,11.2a2.222,2.222,0,0,0-1.518-3.855ZM7.221,15.32A5.578,5.578,0,1,0,14.058,21.3h5.215a2.233,2.233,0,1,0,0-1.116H13.047v.558A4.465,4.465,0,1,1,7.5,16.419Z"
          transform="translate(84.542 68.015)"
          fill="#fb972e"
          stroke="#fb972e"
          stroke-width="0.8"
        />
        <path
          id="Path_10193"
          data-name="Path 10193"
          d="M-5-12.187c-5.523,0-10,3.636-10,8.124A7.18,7.18,0,0,0-12.933.869a9.912,9.912,0,0,1-1.812,2.859.937.937,0,0,0-.18,1.015.94.94,0,0,0,.863.566A9.477,9.477,0,0,0-8.629,3.5,12.064,12.064,0,0,0-5,4.06C.522,4.06,5,.424,5-4.064S.522-12.187-5-12.187ZM-5,2.186a10.15,10.15,0,0,1-3.062-.473l-.887-.281-.762.539A8.4,8.4,0,0,1-11.957,3.1a9.8,9.8,0,0,0,.777-1.57l.414-1.1-.8-.851a5.372,5.372,0,0,1-1.554-3.648c0-3.445,3.644-6.249,8.124-6.249s8.124,2.8,8.124,6.249S-.521,2.186-5,2.186Z"
          transform="translate(29.158 34.511)"
          fill="#fb972e"
          stroke="#fb972e"
          stroke-width="0.5"
        />
        <path
          id="Path_10194"
          data-name="Path 10194"
          d="M6.75-11.25h-19.5A2.25,2.25,0,0,0-15-9V4.5a2.25,2.25,0,0,0,2.25,2.25H6.75A2.25,2.25,0,0,0,9,4.5V-9A2.25,2.25,0,0,0,6.75-11.25ZM6.75-9v1.913C5.7-6.231,4.023-4.9.441-2.1-.348-1.475-1.912.017-3,0-4.088.017-5.652-1.475-6.441-2.1-10.023-4.9-11.7-6.231-12.75-7.087V-9ZM-12.75,4.5V-4.2c1.074.856,2.6,2.056,4.919,3.874C-6.806.48-5.012,2.261-3,2.25-1,2.261.774.506,1.831-.326,4.152-2.144,5.676-3.344,6.75-4.2V4.5Z"
          transform="translate(96.632 22.57)"
          fill="#fb972e"
        />
        <rect
          id="Rectangle_1773"
          data-name="Rectangle 1773"
          width="10"
          height="3"
          rx="1.5"
          transform="translate(67.619 41.698) rotate(-57)"
          fill="#fb972e"
        />
        <rect
          id="Rectangle_1775"
          data-name="Rectangle 1775"
          width="10"
          height="3"
          rx="1.5"
          transform="translate(78.183 55.025) rotate(-9)"
          fill="#fb972e"
        />
        <rect
          id="Rectangle_1774"
          data-name="Rectangle 1774"
          width="10"
          height="3"
          rx="1.5"
          transform="matrix(0.829, -0.559, 0.559, 0.829, 73.011, 47.981)"
          fill="#fb972e"
        />
        <path
          id="Path_10192"
          data-name="Path 10192"
          d="M6.491,3.049C5.628,2.122,4.014.728,4.014-3.839A7.05,7.05,0,0,0-1.7-10.766v-.93a1.428,1.428,0,0,0-1.428-1.429A1.428,1.428,0,0,0-4.553-11.7v.93a7.05,7.05,0,0,0-5.712,6.927c0,4.567-1.614,5.961-2.476,6.888a1.4,1.4,0,0,0-.384.969,1.43,1.43,0,0,0,1.433,1.429H5.442A1.43,1.43,0,0,0,6.875,4.018,1.394,1.394,0,0,0,6.491,3.049Zm-16.6.255c.947-1.249,1.983-3.318,1.988-7.117,0-.009,0-.017,0-.026a5,5,0,0,1,5-5,5,5,0,0,1,5,5c0,.009,0,.017,0,.026,0,3.8,1.041,5.869,1.988,7.117Zm6.985,6.429A2.857,2.857,0,0,0-.269,6.875H-5.981A2.857,2.857,0,0,0-3.125,9.732Z"
          transform="translate(58.8 13.125)"
          fill="#fb972e"
          stroke="#fb972e"
          stroke-width="0.4"
        />
        <g id="Icon" transform="translate(94.632 46.465) rotate(-45)">
          <g id="Union_10" data-name="Union 10" fill="#fff">
            <path
              d="M 13.99949932098389 21.92500114440918 L 4.000499248504639 21.92500114440918 C 2.483869075775146 21.92500114440918 1.249999165534973 20.69153022766113 1.249999165534973 19.17540168762207 L 1.249999165534973 8.875801086425781 C 1.249999165534973 8.820230484008789 1.255949139595032 8.76516056060791 1.267689108848572 8.71212100982666 L 1.289209127426147 8.614880561828613 L 1.295059084892273 8.515470504760742 C 1.318329095840454 8.120060920715332 1.491659164428711 7.762160778045654 1.810229182243347 7.451690673828125 L 7.598089218139648 1.811420798301697 C 7.96937894821167 1.4494708776474 8.474549293518066 1.25023078918457 9.020699501037598 1.25023078918457 C 9.566848754882812 1.25023078918457 10.07201957702637 1.4494708776474 10.44313907623291 1.81126081943512 L 16.23216819763184 7.451790809631348 C 16.68719863891602 7.895441055297852 16.7635498046875 8.365691184997559 16.74742889404297 8.682001113891602 L 16.74375915527344 8.753971099853516 L 16.74838829040527 8.82589054107666 C 16.74945831298828 8.842500686645508 16.75 8.859291076660156 16.75 8.875801086425781 L 16.75 19.17540168762207 C 16.75 20.69153022766113 15.51612949371338 21.92500114440918 13.99949932098389 21.92500114440918 Z"
              stroke="none"
            />
            <path
              d="M 13.99949932098389 20.67500114440918 C 14.82687950134277 20.67500114440918 15.49999904632568 20.00228118896484 15.49999904632568 19.17540168762207 L 15.49999904632568 8.891093254089355 L 15.49170875549316 8.762320518493652 L 15.49904918670654 8.61837100982666 C 15.50101947784424 8.579720497131348 15.50562953948975 8.489231109619141 15.35984897613525 8.347081184387207 L 9.570579528808594 2.7063307762146 C 9.436219215393066 2.575350761413574 9.235798835754395 2.50023078918457 9.020699501037598 2.50023078918457 C 8.805599212646484 2.50023078918457 8.605178833007812 2.575350761413574 8.470489501953125 2.706650733947754 L 2.6826491355896 8.346890449523926 C 2.549509048461914 8.476651191711426 2.544539213180542 8.561150550842285 2.542899131774902 8.588911056518555 L 2.531199216842651 8.787751197814941 L 2.499999046325684 8.928723335266113 L 2.499999046325684 19.17540168762207 C 2.499999046325684 20.00228118896484 3.173119068145752 20.67500114440918 4.000499248504639 20.67500114440918 L 13.99949932098389 20.67500114440918 M 13.99949932098389 23.17500114440918 L 4.000499248504639 23.17500114440918 C 1.790999174118042 23.17500114440918 -8.654785119688313e-07 21.38400077819824 -8.654785119688313e-07 19.17540168762207 L -8.654785119688313e-07 8.875801086425781 C -8.654785119688313e-07 8.726840972900391 0.01630913466215134 8.581690788269043 0.04721913486719131 8.442020416259766 C 0.08621913194656372 7.779420852661133 0.3660791218280792 7.113680839538574 0.9377991557121277 6.556500911712646 L 6.725698947906494 0.9162008166313171 C 7.978498935699463 -0.3050991892814636 10.06289958953857 -0.3050991892814636 11.31569957733154 0.9162008166313171 L 17.10449981689453 6.556500911712646 C 17.76344871520996 7.198980808258057 18.03453826904297 7.985780715942383 17.99580955505371 8.745631217956543 C 17.99857902526855 8.788681030273438 18 8.832060813903809 18 8.875801086425781 L 18 19.17540168762207 C 18 21.38400077819824 16.20899963378906 23.17500114440918 13.99949932098389 23.17500114440918 Z"
              stroke="none"
              fill="#fb972e"
            />
          </g>
          <path
            id="Path_10200"
            data-name="Path 10200"
            d="M1.713,0A1.713,1.713,0,1,1,0,1.713,1.713,1.713,0,0,1,1.713,0Z"
            transform="translate(7.409 6.218)"
            fill="#fb972e"
          />
        </g>
      </g>
    </svg>
  );
}
